import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalDataService {

    constructor() { }

    _currentTab = "ConflictCheck";
    set currentTab(val: string) {
        this._currentTab = val;
    }
}
